import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ServerErrorDialogState {
  visible: boolean;
  errorId: string;
  statusCode: number;
  stackTrace?: string;
  appCode?: number;
  appCodeLabel?: string;
}

@Injectable({ providedIn: 'root' })
export class ServerErrorDialogService {
  private readonly stateSource = new Subject<ServerErrorDialogState>();
  readonly state$ = this.stateSource.asObservable();

  show(errorId: string, statusCode: number, stackTrace?: string, appCode?: number, appCodeLabel?: string): void {
    this.stateSource.next({ visible: true, errorId, statusCode, stackTrace, appCode, appCodeLabel });
  }

  hide(): void {
    this.stateSource.next({ visible: false, errorId: '', statusCode: 0 });
  }
}
